<template>
  <div :class="{'scrolled': isScrolled, [showRoute]: true, [isIntro]: true}">

    <!-- <div id="font-switcher" style="position: fixed; z-index: 9999; bottom: 10px; background-color: grey;">
      <select @change="changeFont($event)">
        <option value="1">Current: Poppins</option>
        <option value="2">Poppins Medium</option>
        <option value="3">Poppins Semi Bold</option> -->
        <!-- <option value="3">Primary: Adobe Garamond Pro Regular, Secondary: Parastoo Regular</option> -->
        <!-- <option value="4">Primary: Parastoo Bold, Secondary: Parastoo Regular</option> -->
        <!-- <option value="5">Primary: Freight Sans Pro, Secondary: Freight Sans Pro</option> -->
       
      <!-- </select>
    </div> -->
    <div id="main" v-cloak>
      <!-- Cookie Banner -->
      <CookieConsentNew 
        :showBannerProp="showBannerPref" 
        @update:showBannerProp="updateShowBannerPref" 
      />           

      <!-- Header -->
      <Appheader />

      <!-- Global Loader -->
      <transition name="fade">
        <div v-if="isLoading" class="page-loader">
          <!-- only show this after delay -->
          <div v-if="showLoaderContent" class="loader-content">
            <img src="/images/Logo-9T-Thick-Black.svg" alt="Logo" class="loader-logo" />
            <span class="loader"></span>
          </div>
        </div>
      </transition>

      <!-- Main Content -->
      <main v-show="!isLoading" class="content-area">
        <router-view v-slot="{ Component }" :key="$route.fullPath">
          <component 
            :is="Component"
            :londonboutique="londonboutique" 
            :genevaboutique="genevaboutique" 
            :siteSettings="siteSettings" 
            @route-data-ready="hideLoader"
          />
        </router-view>
      </main>
    </div>

    <!-- Footer -->
    <Appfooter :londonboutique="londonboutique" :siteSettings="siteSettings"/>
      <!-- <AppFooterNarrow :londonboutique="londonboutique" :siteSettings="siteSettings"/> -->

    <!-- Cookie Banner Access -->
    <div id="cookie-settings">
      <img src="/images/icons/cookies-grey.svg" @click="toggleBanner" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'
import { useStore, mapState } from 'vuex'
import Appheader from './components/Appheader.vue'
import Appfooter from './components/Appfooter.vue'
import AppFooterNarrow from './components/AppFooterNarrow.vue'
import CookieConsentNew from './components/CookieConsentNew.vue'

export default {
  name: 'App',
  components: {
    Appheader,
    Appfooter,
    AppFooterNarrow,
    CookieConsentNew,
  },

  computed: {
    ...mapState('boutiques', ['londonboutique', 'genevaboutique', 'siteSettings']),
  },

  setup() {
    const store = useStore()
    const isScrolled = ref(false)
    const featuredRM = ref([])
    const featuredOther = ref([])
    const isIntro = ref('')
    const showRoute = ref('')
    const showBannerPref = ref(true)
    const route = useRoute()
    const router = useRouter()
    // Global loading
    const isLoading = ref(false) // background + overlay
    const showLoaderContent = ref(false) // logo + spinner
    let loaderTimer = null

    router.beforeEach((to, from, next) => {
      const pageChanged =
        to.path !== from.path ||
        JSON.stringify(to.query) !== JSON.stringify(from.query)

      if (pageChanged) {
        isLoading.value = true
      }

      next()
    })
    

    // Called from children when API finishes
    const hideLoader = () => {
      clearTimeout(loaderTimer)
      isLoading.value = false
      showLoaderContent.value = false
    }

    const toggleBanner = () => {
      showBannerPref.value = !showBannerPref.value
    }

    const updateShowBannerPref = (value) => {
      showBannerPref.value = value
    }

    const getFeaturedWatches = (address) => {
      axios.get(address || '/api/featuredwatches').then((response) => {
        featuredRM.value = response.data[0][0]
        featuredOther.value = response.data[1][0]
      })
    }

    const handleScroll = () => {
      isScrolled.value = window.scrollY > 110
    }

    watch(
      () => route.name,
      (newName) => {
        showRoute.value = newName
      }
    )

    watch(
      () => route,
      (to) => {
        document.title = to.meta.title || 'Ninety'
      }
    )

    onMounted(() => {
      // fetch boutiques + settings once from Vuex
      store.dispatch('boutiques/fetchLondon')
      store.dispatch('boutiques/fetchGeneva')
      store.dispatch('boutiques/fetchSiteSettings')

      window.addEventListener('scroll', handleScroll)
    })

    return {
      featuredRM,
      featuredOther,
      isIntro,
      showRoute,
      showBannerPref,
      toggleBanner,
      updateShowBannerPref,
      getFeaturedWatches,
      isScrolled,
      isLoading,
      hideLoader,
      showLoaderContent,
    }
  },
methods: {
    changeFont(event) {
      const selectedValue = event.target.value;
      this.$changeFont(selectedValue);
    }
  },
  beforeUnmount() {
    window.removeEventListener('scroll', handleScroll)
  },
}
</script>

<style>
/* Fade transition */
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from {
  opacity: 1;
}
.fade-leave-to {
  opacity: 0;
}

/* Loader overlay */
.page-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #f0eeea;
  display: flex;
  flex-direction: column; /* stack logo above spinner */
  justify-content: center;
  align-items: center;
  z-index: 1;
}
.loader-logo {
  opacity: 0;
  width: 80px; /* adjust as needed */
  margin-bottom: 20px;
  animation: fadeIn 0.8s ease forwards;
  animation-delay: 500ms;
}
.loader {
  opacity: 0;
  border: 4px solid #f0eeea;
  border-top: 4px solid #000;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite, fadeIn 0.8s ease forwards;
  animation-delay: 0s, 500ms;
  display: inline-block;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
